import ScrollMagic from "scrollmagic";

export default function () {

    function initScrollMagic() {
        var controller = new ScrollMagic.Controller();
        // var scene = new ScrollMagic.Scene();
        // var enabled = controller.enabled();
        // var $mobileMenu = $('.hamburger');
        // var $html = $('html');

        function disableScrollMagic() {
            controller.enabled(false);
        }

        // $mobileMenu.on('click', function(){
        //     $html.toggleClass('menu-is-open');
        //     controller.enabled(false);
        //
        //     if ($html.hasClass('menu-is-open')) {
        //         $mobileMenu.on('click', function() {
        //             controller.enabled(true);
        //         })
        //     }
        // })
        
        function desktopScrollMagic() {
            console.log('this works');
            const pinHero = new ScrollMagic.Scene({
                triggerElement: '#main-hero',
                triggerHook: 'onLeave',
                duration: '200%',
                //offset: -140
            })
                .setClassToggle('#main-hero', 'stick')
                .setPin('#main-hero')
                .addTo(controller);

            const heroSlider1 = new ScrollMagic.Scene({
                triggerElement: '.col-slider-l',
                triggerHook: 'onLeave',
                duration: '100%',
            })
                .setPin('.col-slider-l')
                .addTo(controller);

            const heroSlider2 = new ScrollMagic.Scene({
                triggerElement: '.col-slider-r',
                triggerHook: 'onLeave',
                duration: '100%',
            })
                .addTo(controller);

            const releaseWrapper = new ScrollMagic.Scene({
                triggerElement: '.col-slider-r',
                triggerHook: 'onLeave',
            })
                .setClassToggle('.main-wrapper', 'release')
                .addTo(controller);

            const dropBorder = new ScrollMagic.Scene({
                triggerElement: '.col-slider-r',
                triggerHook: 'onLeave'
            })
                .setClassToggle('header', 'slide-border')
                .addTo(controller);
        }

        function microclimate() {
            const pinHero = new ScrollMagic.Scene({
                triggerElement: '#main-hero',
                triggerHook: 'onLeave',
                duration: '200%'//,
                //offset: -221
            })
                .setClassToggle('#main-hero', 'stick')
                .setPin('#main-hero')
                .addTo(controller);

            const heroSlider1 = new ScrollMagic.Scene({
                triggerElement: '.col-slider-l',
                triggerHook: 'onLeave',
                duration: '100%'//,
                //offset: -221
            })
                .setPin('.col-slider-l')
                .addTo(controller);

            const heroSlider2 = new ScrollMagic.Scene({
                triggerElement: '.col-slider-r',
                triggerHook: 'onLeave',
                duration: '100%'//,
                //offset: -221
            })
                .addTo(controller);

            const releaseWrapper = new ScrollMagic.Scene({
                triggerElement: '.col-slider-r',
                triggerHook: 'onLeave'//,
                //offset: -221
            })
                .setClassToggle('.main-wrapper', 'release')
                .addTo(controller);

            const dropBorder = new ScrollMagic.Scene({
                triggerElement: '.col-slider-r',
                triggerHook: 'onLeave'
            })
                .setClassToggle('header', 'slide-border')
                .addTo(controller);

            const mcStickyNav = new ScrollMagic.Scene({
                triggerElement: '.col-slider-r',
                triggerHook: 'onLeave'
            })
                .setClassToggle('.mc-dropdown-nav', 'slide-mc-nav')
                .addTo(controller);

            const mcStickyLogo = new ScrollMagic.Scene({
                triggerElement: '.col-slider-r',
                triggerHook: 'onLeave'
            })
                .setClassToggle('.logo-title-container', 'slide-logo-title')
                .addTo(controller);

            const mcNavContainer = new ScrollMagic.Scene({
                triggerElement: '.col-slider-r',
                triggerHook: 'onLeave'
            })
                .setClassToggle('.nav-container', 'slide-nav-container')
                .addTo(controller);
        }

        function stickyNav() {
            console.log('this works');
            const dropBorder2 = new ScrollMagic.Scene({
                triggerElement: '.tier-header',
                triggerHook: 'onLeave'
            })
                .setClassToggle('header', 'slide-border')
                .addTo(controller);
        }

        function microclimateNav() {
            const mcStickyNav2 = new ScrollMagic.Scene({
                triggerElement: '.tier-header',
                triggerHook: 'onLeave'
            })
                .setClassToggle('.mc-dropdown-nav', 'slide-mc-nav')
                .addTo(controller);

            const mcStickyLogo2 = new ScrollMagic.Scene({
                triggerElement: '.tier-header',
                triggerHook: 'onLeave'
            })
                .setClassToggle('.logo-title-container', 'slide-logo-title')
                .addTo(controller);

            const mcNavContainer2 = new ScrollMagic.Scene({
                triggerElement: '.tier-header',
                triggerHook: 'onLeave'
            })
                .setClassToggle('.nav-container', 'slide-nav-container')
                .addTo(controller);
        }

        function checkForSlides() {
            if ($('body').find('.col-slider-l').length) {
                desktopScrollMagic();
            } else if ($('header').find('.microclimate-nav').length) {
                microclimateNav();
            } else if ($('header').find('.tier-header').length) {
                stickyNav();
            } else {
                // $('#main-hero').addClass('dropHero');
                $('.placeholder-class').addClass('dropHero');
            }
        }

        function checkViewPort() {
            if (window.matchMedia("(max-width: 767px)").matches) {
                disableScrollMagic();
            }
        }

        checkViewPort();
        checkForSlides();
        // microclimate();
    }

    function initNavigationScroll() {
        var controller = new ScrollMagic.Controller();
        var $header = $("#header");


        if ($(window).width() < 992 && controller.enabled()) {
            controller.enabled(false);
        }
        else {
            new ScrollMagic.Scene({
                duration: 0,
                triggerHook: 0,
                offset:250,
                reverse: true
            })
                .on("enter", function () {
                    var headerHeight = $header.height();
                    $header.before("<div class='header-container-spacer' style='height:"+headerHeight+"px'></div>");
                    $header.addClass("fixed-top slide-down");
                })
                .on("leave", function () {
                    $header.removeClass("fixed-top slide-down");
                    $(".header-container-spacer").remove();
                })
                .addTo(controller);
        }

        $(window).resize( function () {
            if ($(window).width() < 992 && controller.enabled()) {
                controller.enabled(false);
            }
            else {
                controller.enabled(true);
            }
            controller.update(true);
        });
    }

    initNavigationScroll();
    initScrollMagic();
};





// WEBPACK FOOTER //
// ./src/ui/js/apps/scrollmagic.js